'use client';

import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Professional } from '@interface/clinic';
import ProfessionalCard from 'app/(web)/components/common/ProfessionalCard';
import WebProfessionalsModal from 'app/(web)/components/common/WebProfessionalsModal';
import FullWidthCarousel from 'app/(web)/components/product/fullWidthCarousel';
import Carousel from 'designSystem/Carousel/Carousel';
import { Container } from 'designSystem/Layouts/Layouts';
import { Title } from 'designSystem/Texts/Texts';

export default function VithasProfessionals({
  professionals,
}: {
  professionals: Professional[];
}) {
  const [selectedProfessional, setSelectedProfessional] =
    useState<Professional | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleProfessionalClick = (professional: Professional) => {
    setSelectedProfessional(professional);
    setIsModalOpen(true);
  };

  const handleCloseModal = (open: boolean) => {
    setIsModalOpen(open);
    if (!open) {
      setSelectedProfessional(null);
    }
  };

  return (
    <>
      <div className="bg-hg-secondary100 py-16 -mt-6 md:mt-0">
        <Container className={`p-0 md:px-4 gap-16 justify-between md:mb-8`}>
          <Container className="md:px-0 md:flex md:flex-col md:justify-center md:items-start">
            <Title size="2xl" className="mb-4">
              Conoce a los Cirujanos especialistas del Grupo Vithas
            </Title>
          </Container>
          {professionals.length < 3 && (
            <Carousel
              hasDots={isMobile}
              className="relative"
              visibleSlides={isMobile ? 1 : 2}
              dragEnabled={isMobile}
            >
              {professionals.map(professional => {
                if (professional.urlPhoto) {
                  return (
                    <ProfessionalCard
                      key={professional.name}
                      professional={professional}
                      className="h-full flex flex-col"
                      clickable={true}
                      onClick={handleProfessionalClick}
                      showMoreButton
                    />
                  );
                }
              })}
            </Carousel>
          )}
        </Container>

        {professionals.length > 2 && (
          <FullWidthCarousel
            hasDots={isMobile}
            hasControls={!isMobile}
            className="relative"
            visibleSlides={isMobile ? 1 : 2.66}
            dragEnabled={isMobile}
          >
            {professionals.map(professional => {
              if (professional.urlPhoto) {
                return (
                  <ProfessionalCard
                    key={professional.name}
                    professional={professional}
                    className="h-full flex flex-col pl-0"
                    clickable={true}
                    onClick={handleProfessionalClick}
                    showMoreButton
                  />
                );
              }
            })}
          </FullWidthCarousel>
        )}
      </div>

      <WebProfessionalsModal
        professional={selectedProfessional}
        open={isModalOpen}
        onOpenChange={handleCloseModal}
      />
    </>
  );
}
